import { useSettings } from "@/context/SettingsContext";

export function Logo({ size = "md", className = "" }) {
  const { settings } = useSettings();
  const dims = size === "lg" ? "h-12" : size === "sm" ? "h-7" : "h-9";

  if (settings?.logo_image) {
    return (
      <img
        src={settings.logo_image}
        alt={settings?.brand_name || "Luxury Hair by DEMJ"}
        className={`${dims} w-auto object-contain ${className}`}
        data-testid="brand-logo-img"
      />
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo-text">
      <div className="relative">
        <span
          className="font-serif text-[#D4AF37] tracking-[0.18em] font-bold leading-none"
          style={{ fontSize: size === "lg" ? "1.5rem" : size === "sm" ? "0.95rem" : "1.15rem" }}
        >
          DEMJ
        </span>
        <span className="absolute -top-1 -right-2 w-1.5 h-1.5 bg-[#D4AF37] rounded-full" />
      </div>
      <div className="hidden sm:flex flex-col leading-tight">
        <span className="text-[0.55rem] tracking-[0.32em] text-white/50 uppercase">Luxury Hair by</span>
        <span className="text-[0.65rem] tracking-[0.32em] text-[#D4AF37] uppercase">DEMJ</span>
      </div>
    </div>
  );
}
